<div class="d-flex flex-column main-container">
    @if (!effectivenessModel.useControlExecution) {
        <eff-radio-group
            [options]="sampleTypeOptions"
            [(model)]="samplingInformation.sampleType"
            [label]="'effSampleTypeStep.selectSampleType' | t"
            (modelChange)="sampleTypeChanged()"
            data-uiid="new-eff-generate-samples-sample-type-radio-group"
        ></eff-radio-group>
        @if (isSpreadsheet()) {
            <div class="d-flex flex-row row-items align-items-start">
                <eff-input
                    type="text"
                    [label]="'effSampleTypeStep.idColumn' | t"
                    class="row-item"
                    [formController]="sampleFormGroup.idColumnFormControl"
                    data-uiid="new-eff-generate-samples-spreadsheet-id-column"
                ></eff-input>
                <eff-input
                    type="number"
                    [label]="'effSampleTypeStep.rowsToSkip' | t"
                    class="row-item"
                    [formController]="sampleFormGroup.rowsToSkipFormControl"
                    data-uiid="new-eff-generate-samples-spreadsheet-rows-to-skip"
                ></eff-input>
            </div>
        }
    }

    <div class="d-flex flex-row row-items align-items-start">
        @if (!hidePopulationSize()) {
            <eff-input
                type="number"
                [label]="'effSampleTypeStep.populationSize' | t"
                class="row-item"
                [disabled]="isSpreadsheet() || effectivenessModel.useControlExecution"
                [formController]="sampleFormGroup.populationSizeFormControl"
                data-uiid="new-eff-generate-samples-population-size"
            ></eff-input>
        }
        <eff-input
            type="number"
            [label]="'effSampleTypeStep.testSamples' | t"
            class="row-item"
            [formController]="sampleFormGroup.numberOfTestSamplesFormControl"
            data-uiid="new-eff-generate-samples-test-samples"
        ></eff-input>
        @if (hidePopulationSize()) {
            <div class="row-item"></div>
        }
    </div>
</div>
